<template>
  <a-page-header :subTitle="subTitle" @back="$emit('back')" class="page-header">
    <template slot="title">
      <slot></slot>
    </template>
  </a-page-header>
</template>

<style lang="scss">
.page-header {
  &.ant-page-header {
    padding: 0;
    .ant-page-header-heading-title {
      font-weight: 700;
    }
  }
}
</style>
<script>
export default {
  name: "PageHeader",
  props: {
    subTitle: {
      type: String,
      default: "",
    },
  },
};
</script>

<style lang="scss" scoped>
.page-header {
  ::v-deep .ant-page-header-heading {
    display: flex;
    align-items: center;
    .anticon {
      svg {
        fill: #0379b0;
      }
    }
  }
}
</style>
